// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"OS-z","categoryName":"PS-z","categoryNameSearchHeader":"QS-z","categoryContent":"RS-z","bottomAligned":"SS-z","image":"TS-z","imageNoBackground":"US-z"};